import { useAppDispatch } from '@hooks/reduxHooks';
import { setCrmFields } from '@reducers/CrmFieldSlice';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useCrmField = (props: { enabled?: boolean } = {}) => {
  const dispatch = useAppDispatch();

  return useQuery<crmModels.ICrmField[]>({
    queryKey: [crmConstants.queryKeys.CRM_FIELD],
    queryFn: async () => {
      const res = await $api.get('/v1/crm/field');

      return res?.data?.data;
    },
    onSuccess: data => {
      dispatch(setCrmFields({ data: data! }));
    },
    enabled: props?.enabled
  });
};
